'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMobileSize = exports.gridSizeSelector = exports.getGridSizeName = exports.getGridSize = undefined;

var _gridConstants = require('./gridConstants');

var getGridSize = exports.getGridSize = function getGridSize(state) {
    return state.getIn(['app', 'gridSize', 'size']);
}; // Constants
var getGridSizeName = exports.getGridSizeName = function getGridSizeName(state) {
    return state.getIn(['app', 'gridSize', 'name']);
};

var gridSizeSelector = exports.gridSizeSelector = function gridSizeSelector(state) {
    return {
        gridSize: getGridSize(state)
    };
};

var isMobileSize = exports.isMobileSize = function isMobileSize(state) {
    return getGridSizeName(state) === _gridConstants.GRID.MOBILE.name;
};

exports.default = getGridSize;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/grid/gridSizeSelector.js
// module id = 66
// module chunks = 0